import styled from 'styled-components';

export const HeaderButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  & > fieldset > div {
    display: flex;
    align-items: center;

    & > button {
      margin-left: 0px;
    }
  }
`;
